import React from 'react'
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  const currentTime = new Date()
  const currentYear = currentTime.getFullYear()
  const tenantKey = localStorage.getItem('tenantKey')

  const footerText =
    tenantKey === 'RAYBIZTECH' || tenantKey === 'RAYBIZTECHR'
      ? `Copyright © Ray Business Technologies ${currentYear}`
      : `Copyright © AIBridgeML ${currentYear}`

  return <CFooter className="main-footer">{footerText}</CFooter>
}

export default React.memo(AppFooter)
